import { h, VNode } from 'vue'

export function mapDomNodesToVNodes(
  nodes: NodeListOf<ChildNode> | ChildNode[],
  replacements: Record<
    string,
    (el: HTMLElement, index: Number) => VNode | undefined
  > = {},
  index: Ref<number>
): VNode[] {
  return Array.from(nodes)
    .map((node) => {
      index.value++

      // Equivalent to Node.ELEMENT_NODE
      if (node.nodeType === 1) {
        const element = node as HTMLElement

        // Check if the element has the 'sc-custom-gallery' class
        for (const className of Object.keys(replacements)) {
          if (element.classList.contains(className)) {
            // Replace this node with a custom vNode
            return replacements[className](element, index.value)
          }
        }

        const attrs = {} as Record<string, string>
        for (const attr of element.attributes) {
          attrs[attr.name] = attr.value
        }

        // Recursively handle child nodes
        const children = mapDomNodesToVNodes(
          element.childNodes,
          replacements,
          index
        )

        return h(element.tagName.toLowerCase(), attrs, children)
      }

      // Equivalent to Node.TEXT_NODE
      if (node.nodeType === 3) {
        return node.nodeValue
      }

      // Skip comments and other node types
      return null
    })
    .filter((n): n is VNode => n !== null)
}
